module.exports = __webpack_public_path__ + "media/images/components/c01-page-header/wave-1f959ca9257547c3cd66bdbad0a7f68d.svg";